// Module
var code = `<i class="{{ (pinButtonController.isPinned) ? 'fa fa-star color--env_base_bg' : 'fa fa-star-o'}}" ng-click="pinButtonController.addOrRemove(\$event)" uib-tooltip="{{ (pinButtonController.isPinned ? 'Generic.Unpin' : 'Generic.Pin') | translate }}" tooltip-placement="bottom" tooltip-append-to-body="true"> </i> `;
// Exports
module.exports = code;